import { forwardRef } from 'react';
import combineClasses from 'classnames';
import styles from './SecondaryButton.module.scss';

interface SecondaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  small?: boolean;
  tiny?: boolean;
  noborder?: boolean;
}

const SecondaryButton = forwardRef<HTMLDivElement, SecondaryButtonProps>((props, ref) => {
  const { small, tiny, noborder, disabled, className, ...otherProps } = props;
  const combinedClasses = combineClasses(
    {
      [`${styles.secondaryButton}`]: true,
      [`${styles.small}`]: small,
      [`${styles.tiny}`]: tiny,
      [`${styles.noborder}`]: noborder,
      [`${styles.disabled}`]: disabled,
    },
    className,
  );
  return (
    <div className={combinedClasses} ref={ref}>
      <button type='button' disabled={disabled} {...otherProps}>
        {otherProps.children}
      </button>
    </div>
  );
});
SecondaryButton.displayName = 'SecondaryButton';
export default SecondaryButton;
